// removed by extract-text-webpack-plugin
module.exports = {"socialLink":"src-components-Breach-BreachHero-SocialShare----SocialShare-module---socialLink---1ZlW4","button":"src-components-Breach-BreachHero-SocialShare----SocialShare-module---button---D5tE7","subscribeWrapper":"src-components-Breach-BreachHero-SocialShare----SocialShare-module---subscribeWrapper---2HLo7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Breach/BreachHero/SocialShare/SocialShare.module.css
// module id = 723
// module chunks = 28901507966785